//2. fix/google-serv-batch-bugs | September 25th 2025: Disable the submit button initially and enable it only on change.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    // Cache initial form data to detect changes
    this.formElement = this.element.tagName === 'FORM' ? this.element : this.element.closest('form')
    if (!this.formElement) return

    this.initialSerialized = this.serializeForm(this.formElement)

    // Disable submit initially; will be enabled only on change
    if (this.hasSubmitTarget) {
      this.disableSubmit(true)
    }

    // Listen to input changes within the form
    this.onInputBound = this.onInput.bind(this)
    this.formElement.addEventListener('input', this.onInputBound)
    this.formElement.addEventListener('change', this.onInputBound)
  }

  disconnect() {
    if (this.formElement && this.onInputBound) {
      this.formElement.removeEventListener('input', this.onInputBound)
      this.formElement.removeEventListener('change', this.onInputBound)
    }
  }

  onInput() {
    const current = this.serializeForm(this.formElement)
    const isDirty = current !== this.initialSerialized
    this.disableSubmit(!isDirty)
  }

  disableSubmit(disabled) {
    if (!this.hasSubmitTarget) return
    const btn = this.submitTarget
    btn.disabled = disabled
    btn.classList.toggle('is-static', disabled)
    btn.classList.toggle('is-primary', !disabled)
  }

  serializeForm(form) {
    // Serialize form values in a stable way; ignore disabled inputs and non-data controls
    const pairs = []
    const elements = Array.from(form.elements).filter(el => {
      if (!el.name) return false
      if (el.disabled) return false
      const tag = (el.tagName || '').toLowerCase()
      const type = (el.type || '').toLowerCase()
      if (['button'].includes(tag)) return false
      if (['submit', 'button', 'reset', 'image'].includes(type)) return false
      return true
    })

    elements.forEach(el => {
      const name = el.name
      let value
      const type = (el.type || '').toLowerCase()

      if (type === 'checkbox') {
        value = el.checked ? '1' : '0'
      } else if (type === 'radio') {
        if (el.checked) {
          value = el.value
        } else {
          return
        }
      } else if (el.tagName.toLowerCase() === 'select' && el.multiple) {
        value = Array.from(el.options).filter(o => o.selected).map(o => o.value).join(',')
      } else {
        value = el.value == null ? '' : String(el.value)
      }

      pairs.push(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`)
    })

    pairs.sort()
    return pairs.join('&')
  }
} 